export type MenuItemType = {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    children?: MenuItemType[];
};

const SUPPORT_MENU_ITEMS: MenuItemType[] = [
    {
        key: "dashboard",
        label: "Dashboard",
        isTitle: false,
        icon: "uil-home-alt",
        url: "/support/dashboard",
    },
    {
        key: "app-other",
        label: "Other",
        isTitle: false,
        icon: "mdi mdi-chart-arc",
        url: "/support/dashboard",
        children: [
            {
                key: "other-conflicts",
                label: "Conflicts",
                url: "/support/conflicts",
                parentKey: "app-other",
            },
        ],
    },
    {
        key: "app-owners",
        label: "Owners",
        isTitle: false,
        icon: "mdi mdi-account-key-outline",
        url: "/support/owners",
    },
    {
        key: "app-store-groups",
        label: "Store Groups",
        isTitle: false,
        icon: "mdi mdi-store-marker",
        url: "/support/storegroups",
    },
    {
        key: "app-stores",
        label: "Stores",
        isTitle: false,
        icon: "mdi mdi-store",
        url: "/support/stores",
    },
    {
        key: "app-users",
        label: "Users",
        isTitle: false,
        icon: "uil-users-alt",
        url: "/support/users",
    },
    {
        key: "app-multistore",
        label: "Multi-Store",
        isTitle: false,
        icon: "mdi mdi-shopping",
        children: [
            // {
            //     key: "multistore-advanced",
            //     label: "Edit Multistore",
            //     url: "/support/multistore/advanced",
            //     parentKey: "app-multistore",
            // },
            {
                key: "multistore-simple",
                label: "Edit Multi-Store",
                url: "/support/multistore/simple",
                parentKey: "app-multistore",
            },
        ],
    }
];

export { SUPPORT_MENU_ITEMS };
